<template>
  <HPopup class="h-market-popup"
          ref="popup"
          v-show="visible">
    <div class="h-market-popup-body">
      <p class="popup-header">交易所</p>
      <!-- 金币 -->
      <div class="top-row h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <div class="cargo-tabs">
          <button v-click-sound-button
                  class="tab h-btn ADOPB2ON"
                  :class="{ active: item.id === activeTab }"
                  v-for="item in sellTabs"
                  @click="activeTab=item.id">
            {{ item.name }}
          </button>
        </div>

        <div class="hero-gold">
          <img class="icon" :src="`${$rHost}/img/common/resource/GOLDICON.png`" alt="">
          <span class="gold-value h-title nowrap" :data-title="`当前拥有 ${gold } 金币`">{{ gold }}</span>
        </div>

        <div class="cargo-tabs">
          <button v-click-sound-button
                  class="tab h-btn ADOPB2ON"
                  :class="{ active: item.id === activeTab }"
                  v-for="item in purchaseRequestTabs"
                  @click="onTabClick(item)">
            {{ item.name }}
          </button>
        </div>
      </div>

      <div class="tab-content">
        <!-- 寄卖 -->
        <SellList v-if="activeTab === 1"></SellList>
        <SellBackpackItem v-else-if="activeTab === 2"></SellBackpackItem>
        <UserSellList v-else-if="activeTab === 3"></UserSellList>
        <!-- 收购 -->
        <PurchaseRequestList ref="purchaseRequestList" v-else-if="activeTab === 4"></PurchaseRequestList>
        <PublishPurchase ref="publishPurchasePopup" v-else-if="activeTab === 5"></PublishPurchase>
        <UserPurchaseRequestList ref="userPurchaseRequestList" v-else-if="activeTab === 6"></UserPurchaseRequestList>
      </div>

      <div class="footer">
        <button ref="button"
                v-click-sound-button
                class="h-button ok"
                @click="handleClose">
        </button>
      </div>
    </div>

  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import { mapGetters } from 'vuex'
  import AudioCtrl from '@js/audio-ctrl'
  import SellList from './sell-list'
  import SellBackpackItem from './sell-backpack-item'
  import UserSellList from './user-sell-list'
  import PurchaseRequestList from './purchase/purchase-request-list'
  import UserPurchaseRequestList from './purchase/user-purchase-request-list'
  import PublishPurchase from './purchase/publish'
  import AUDIO from '@/js/constants/AUDIO'

  export default {
    components: {
      HPopup,
      SellList,
      SellBackpackItem,
      UserSellList,
      PurchaseRequestList,
      UserPurchaseRequestList,
      PublishPurchase,
    },

    beforeDestroy () {
      AudioCtrl.stop(this.audioId)
    },

    data () {
      return {
        sellList: [],
        activeTab: 1,
        buyLoading: false,
        audioId: null,

        sellShow: false,
        sellItemInfo: null,

        sellTabs: [
          {
            id: 1,
            name: '寄卖列表',
          },
          {
            id: 2,
            name: '我要寄卖',
          },
          {
            id: 3,
            name: '我的寄卖',
          },
        ],

        purchaseRequestTabs: [
          {
            id: 4,
            name: '收购列表',
          },
          {
            id: 5,
            name: '我要收购',
          },
          {
            id: 6,
            name: '我的收购',
          },
        ],
        purchaseRequestPopupShow: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    watch: {
      visible (val) {
        if (val) {
          this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.LOOPMINE, loop: false })
        } else {
          AudioCtrl.stop(this.audioId)
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold',
      ]),
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.LOOPMARK, loop: false })
    },

    methods: {
      onTabClick (item) {
        this.activeTab = item.id
      },

      handleClose () {
        this.$emit('close', false)
      },

    },

  }
</script>

<style lang="stylus" scoped>
  .h-market-popup-body
    width 728px

  .h-shop-header
    margin-bottom 30px
    text-align center
    letter-spacing 5px
    goldText()

  .top-row
    display flex
    justify-content space-between
    padding 3px 5px

  .hero-gold
    display flex
    align-items center
    justify-content flex-end
    .icon
      height 14px
      vertical-align middle
    .gold-value
      display inline-block
      padding-left 10px
      line-height 14px
      font-size 12px
      letter-spacing 1px
      whiteText1()
      cursor help

  .cargo-tabs
    display flex
    .h-btn
      goldText1()
      margin-right 5px
      width 70px
      height 30px
      font-size 12px
      letter-spacing 1px
      filter grayscale(0.75)
      &:hover
        filter grayscale(0.5)
      &.active
        filter grayscale(0)

  .tab-content
    height 285px
    padding-top 5px

  .footer
    margin-top 30px
    text-align center
    > button
      box-sizing content-box
      border 2px solid $colorGold

</style>
